import { formatPrice } from '@/helpers/priceFormat'

export default {
	install(Vue) {
		Vue.prototype.$tp = formatPrice
	},
}
